import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-16 px-4 bg-purple-900 text-white relative overflow-hidden" data-id="element-120">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-121">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] bg-white rounded-full blur-3xl" data-id="element-122" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] bg-purple-400 rounded-full blur-3xl" data-id="element-123" />
      </div>

      <div className="max-w-md mx-auto relative z-10" data-id="element-124">
        <div className="text-center mb-8" data-id="element-125">
          <h2 className="text-2xl font-bold text-purple-200 mb-2" data-id="element-126">
            Oferta especial por lanzamiento
          </h2>
          <h3 className="text-3xl font-black text-white leading-tight" data-id="element-127">
            MEGA PACK TERAPÉUTICO <br data-id="element-128" /> PARA PSICÓLOGAS™
          </h3>
          <p className="text-purple-200 mt-2 font-medium" data-id="element-129">
            + 3 bonos exclusivos de regalo
          </p>
        </div>

        <div className="bg-white text-gray-900 rounded-3xl p-8 shadow-2xl border-4 border-purple-400/30 backdrop-blur-sm relative" data-id="element-130">
          {/* Price Tag */}
          <div className="text-center mb-8" data-id="element-131">
            <span className="text-gray-400 line-through text-lg font-medium" data-id="element-132">
              Antes $49 USD
            </span>
            <div className="flex items-center justify-center gap-2 mt-1" data-id="element-133">
              <span className="text-5xl font-black text-purple-700" data-id="element-134">$13</span>
              <span className="text-xl font-bold text-gray-600 self-end mb-2" data-id="element-135">
                USD
              </span>
            </div>
            <div className="inline-block bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold mt-3 uppercase tracking-wide" data-id="element-136">
              Ahorras 70% Hoy
            </div>
          </div>

          {/* Features */}
          <ul className="space-y-4 mb-8" data-id="element-137">
            {['Acceso inmediato a todo el material', '24 Sesiones completas', 'Protocolos y Hojas de trabajo', '3 Bonos de Regalo (Mapa, Checklist, Kit)', 'Descarga ilimitada de por vida', 'Garantía de satisfacción de 7 días'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-138">
                <div className="w-5 h-5 rounded-full bg-purple-100 flex items-center justify-center flex-shrink-0" data-id="element-139">
                  <Check className="w-3 h-3 text-purple-600" data-id="element-140" />
                </div>
                <span className="text-sm font-medium text-gray-700" data-id="element-141">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* CTA */}
          <CTAButton text="SÍ, QUIERO EL MEGA PACK" subtext="Descarga inmediata • Pago seguro" fullWidth={true} className="mb-4" data-id="element-142" />

          <div className="flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-143">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-144" />
            <span data-id="element-145">Pago seguro y encriptado</span>
          </div>
        </div>
      </div>
    </section>;
}